(function () {

    "use strict";

    function manualesService(basicEntityService, entityService, $translate) {

        var self = this;
        self.entityService = entityService.resource("manuales");

        var labels = {
            propertyName: "aplicacion",
            updateOk: $translate.instant("MANUAL.OKMODIFICACION"),
            updateError: $translate.instant("MANUAL.ERRORMODIFICACION"),
            createOk: $translate.instant("MANUAL.CONFIRMARELIMINACIONTITULO"),
            createError: $translate.instant("MANUAL.CONFIRMARELIMINACIONTITULO"),
            confirmDeleteContent: $translate.instant("MANUAL.CONFIRMARELIMINACIONCONTENIDO"),
            confirmDeleteTitle: $translate.instant("MANUAL.CONFIRMARELIMINACIONTITULO"),
            confirmDeleteOK: $translate.instant("MANUAL.CONFIRMARELIMINACIONOK"),
            confirmDeleteCancel: $translate.instant("MANUAL.CONFIRMARELIMINACIONCANCELAR"),
            deletedOk: $translate.instant("MANUAL.OKDELETE"),
            deletedCancel: $translate.instant("MANUAL.ERRORDELETE")
        };

        basicEntityService.instantiate(self, labels);
    }

    manualesService.$inject = ["sphforms.basicEntityService", "solpheo.entityService", "$translate"];

    angular.module("sphforms.formacion").service("sphforms.manualesService", manualesService);

})();
